import { action } from 'typesafe-actions';
import { DataActionTypes } from './types';
import { IAgent } from '../../types';
import { IModal } from '../ui/types';
import { ConfigActionTypes } from '../config/types';

export const getAgents = (searchQuery?: string) => action(DataActionTypes.GET_AGENTS, searchQuery);

export const setUniConfigLoaded = (payload: boolean) => action(ConfigActionTypes.SET_UNI_CONFIG_LOADED, payload);
export const setStudentConfigLoaded = (payload: boolean) =>
  action(ConfigActionTypes.SET_STUDENT_CONFIG_LOADED, payload);

export const getAgentsSuccess = (agents: IAgent[]) => action(DataActionTypes.GET_AGENTS_SUCCESS, agents);
export const getAgentsFailure = (error: string) => action(DataActionTypes.GET_AGENTS_FAILURE, error);

export const setIsWsPaused = (isPaused: boolean) => action(DataActionTypes.SET_IS_WS_PAUSED, { isPaused });

export const debounceWsMessage = (wsActionPayload: any) => action(DataActionTypes.DEBOUNCE_WS_ACTION, wsActionPayload);

export const resendWSMessage = (wsAction: any) => action('REDUX_WEBSOCKET::MESSAGE', wsAction);

export const retryAPICall = (callName: string, retryNumber: number, timeToNextCall: number) =>
  action(DataActionTypes.RETRY_API_CALL, {
    callName,
    retryNumber,
    timeToNextCall,
  });
export const retryAPICallSuccess = (callName: string) => action(DataActionTypes.RETRY_API_CALL_SUCCESS, callName);
export const retryAPICallFailure = (callName: string, error: string) =>
  action(DataActionTypes.RETRY_API_CALL_FAILED, { callName, error });

export const getUploadUrl = (openModal: IModal, fileName: string, fileType: string, fileIndex: number, file: File) =>
  action(DataActionTypes.GET_UPLOAD_FILE_URL, {
    openModal,
    fileName,
    fileType,
    fileIndex,
    file,
  });

export const getUploadUrlFailure = (error: string, fileData?: { name: string; index: number }) =>
  action(DataActionTypes.GET_UPLOAD_FILE_URL_FAILURE, {
    error,
    fileData,
  });

export const uploadFile = (file: File, url: string) =>
  action(DataActionTypes.UPLOAD_FILE, {
    file,
    url,
  });

export const uploadFileSuccess = (
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  interviewType: string,
  eventType: string,
  eventKey: string,
  interviewHash: string,
  attemptHash: string,
  fileNames: string[],
  isFinanceDocumentModal: boolean,
  isFollowUpDocumentModal: boolean,
  isInterviewDocumentModal: boolean,
  isRecordedInterviewDocumentModal: boolean,
) =>
  action(DataActionTypes.UPLOAD_FILE_SUCCESS, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    interviewType,
    eventType,
    eventKey,
    interviewHash,
    attemptHash,
    fileNames,
    isFinanceDocumentModal,
    isFollowUpDocumentModal,
    isInterviewDocumentModal,
    isRecordedInterviewDocumentModal,
  });

export const uploadFileFailure = (error: string) =>
  action(DataActionTypes.UPLOAD_FILE_FAILURE, {
    error,
  });

export const deleteFile = (
  fileName: string,
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  interviewType: string,
  eventType: string,
  eventKey: string,
  interviewHash: string,
  attemptHash: string,
  isFinance: boolean,
  isFollowUp: boolean,
  isInterview: boolean,
  isRecordedInterview: boolean,
  deletedBy: string | undefined,
) =>
  action(DataActionTypes.DELETE_FILE, {
    fileName,
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    interviewType,
    eventType,
    eventKey,
    interviewHash,
    attemptHash,
    isFinance,
    isFollowUp,
    isInterview,
    isRecordedInterview,
    deletedBy,
  });

export const deleteFileFailure = (error: string) => action(DataActionTypes.DELETE_FILE_FAILURE, { error });
